import { checkedAddressSchema } from '@sparkdotfi/common-universal'
import { z } from 'zod'

import { hexSchema, normalizedNumberSchema } from '@/domain/common/validation'

export const pointsRewardsResponseSchema = z.array(
  z.object({
    root_hash: hexSchema,
    epoch: z.number(),
    wallet_address: checkedAddressSchema,
    token_address: checkedAddressSchema,
    token_price: normalizedNumberSchema.nullish(),
    proof: z.array(hexSchema),
    restricted_country_codes: z.array(z.string()),
    amount_normalized: normalizedNumberSchema,
  }),
)
